import axios from 'axios'

export const companiesStoreGmbInfos = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    mainCategory: null,
    subCategories: null,
    features: null,
    serviceOptions: null,
  },
  mutations: {
    readStoreGmbInfos(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    readStoreGmbInfosSuccess(state, payload) {
      state.data = payload.data
      state.mainCategory = state.data.filter(info => info.kind == 'main_category')
      // state.subCategories = state.data.filter(info => info.kind == 'sub_category')
      state.subCategories = [{'kind': 'sub_category', 'name': 'hoge'}, {'kind': 'sub_category', 'name': 'hoge'}]
      state.features = state.data.filter(info => info.kind == 'feature')
      state.serviceOptions = state.data.filter(info => info.kind == 'service_option')
      state.loading = false
      state.loadError = false
    },
    readStoreGmbInfosFailure(state) {
      state.loading = false
      state.loadError = true
    },
    setMainCategory(state, val) {
      state.mainCategory = val
    },
    setSubCategories(state, val) {
      state.subCategories = val
    },
    setFeatures(state, val) {
      state.features = val
    },
    setServiceOptions(state, val) {
      state.serviceOptions = val
    },
    updateStoreGmbInfos(state) {
      state.loading = true
    },
    updateStoreGmbInfosSuccess(state) {
      state.loading = false
    },
    updateStoreGmbInfosFailure(state) {
      state.loading = false
    }
  },
  actions: {
    mainCategory({ commit }, val) {
      commit('mainCategory', val)
    },
    setSubCategories({ commit }, val) {
      commit('setSubCategories', val)
    },
    setFeatures({ commit }, val) {
      commit('setFeatures', val)
    },
    setServiceOptions({ commit }, val) {
      commit('setServiceOptions', val)
    },
    readStoreGmbInfos({ commit }, { company_uuid, store_uuid }) {
      commit('readStoreGmbInfos')
      commit('readStoreGmbInfosSuccess', {data: []})
      axios
        .get('/companies/' + company_uuid + '/stores/' + store_uuid + '/store_gmb_infos.json')
        .then(res => {
          commit('readStoreGmbInfosSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreGmbInfosFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    updateStoreGmbInfos({ commit }, {company_uuid, store_uuid, payment_methods}) {
      commit('flash/clearFlash', null, { root: true })
      commit('updateStoreGmbInfos')
      const data = { store_payment_method: payment_methods }
      axios
        .put('/companies/' + company_uuid + '/stores/' + store_uuid + '/store_gmb_infos', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(() => {
          commit('updateStoreGmbInfosSuccess')
          commit('flash/updateFlash', { type: 'notice', message: '決済手段を更新しました' }, { root: true })
        })
        .catch(err => {
          commit('updateStoreGmbInfosFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
  },
}
